import type { LocalDate } from 'src/utilities/local-date.js';
import { BaseInstanceRule } from './base-instance-rule.js';
import { t } from 'src/i18n';

export class MonthlyByDayOfMonthInstanceRule extends BaseInstanceRule {
  // Bygges lazy slik at i18n-`t()` kjøres ved kalltid, ikke ved import.
  private static intervalDescriptions(): string[] {
    return [
      '',
      t('recurrence.intervals.monthly.second'),
      t('recurrence.intervals.monthly.third'),
      t('recurrence.intervals.monthly.fourth'),
      t('recurrence.intervals.monthly.fifth'),
      t('recurrence.intervals.monthly.sixth'),
    ];
  }
  private readonly byMonthDay: number;

  public constructor(byMonthDay: number) {
    super();
    this.byMonthDay = byMonthDay;
  }

  public matches(date: LocalDate): boolean {
    return date.day() === this.byMonthDay;
  }

  public optionsToString(interval: number): string {
    return 'FREQ=MONTHLY;INTERVAL=' + interval + ';BYMONTHDAY=' + this.byMonthDay;
  }

  public scheduleDescription(interval: number): string {
    const i = MonthlyByDayOfMonthInstanceRule.intervalDescriptions()[interval - 1];
    return t('recurrence.descriptions.monthlyByDayOfMonth', {
      interval: i,
      day: this.byMonthDay,
    });
  }
}
